import { render, staticRenderFns } from "./SyncItemModal.vue?vue&type=template&id=268a50eb&"
import script from "./SyncItemModal.vue?vue&type=script&lang=js&"
export * from "./SyncItemModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports